import { Component, ViewChild } from '@angular/core';
import { CredentialActivityEndpoint } from '@core/endpoints/credential-activity.endpoint';
import { EnumUserLoginStatus } from '@core/framework/sysenums.enum';
import { BaseState, CredentialType, CredentialLogin, CredentialLoginParams } from '@base/entities/BaseEntities';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { DataSourceCustomAction } from '@base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@base/datalayer/DataLoadOptions';
import { DateHelpers } from '@core/helpers/DateHelpers';
import { ToolbarSettings } from '@base/classes/BaseClasses';
import {
    CredentialLoginHistoryGridComponent
} from '@ui/components/general/credential-login-history/grid/credential-login-history-grid.component';
import { WebAPICredentialEndpoint } from '@m4u-angular/core/endpoints/webapi-credential.endpoint';

export class State extends BaseState {
    CurrentCredentialID: number;
    DateFrom: Date;
    DateTo: Date;
    Status: EnumUserLoginStatus;
    CredentialType: number = -1;

    CredentialsInfo: CredentialType[] = [];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-credential-login-history',
    templateUrl: './credential-login-history.component.html'
})
export class CredentialLoginHistoryComponent extends BasePageComponent<CredentialLogin, State> {

    @ViewChild(CredentialLoginHistoryGridComponent) grid: CredentialLoginHistoryGridComponent;

    constructor(A: ServiceBagService, private credentialActivityEndpoint: CredentialActivityEndpoint,
        private webAPICredentialEndpoint: WebAPICredentialEndpoint) {
        super(A, 'CredentialLoginHistoryComponent', CredentialLogin, State);
    }

    protected override OnInitComponent() {
        this.InitState();
        this.LoadDataSource();
        this.LoadCredentials();

        this.Do(this.credentialActivityEndpoint.ListCredentialTypes(), false, (response) => {
            this.State.CredentialsInfo = response.Entities;
        });
    }

    private LoadDataSource() {
        this.DataSources['UserLogins'] = new DataSourceCustomAction((options: DataLoadOptions) => {
            const params = new CredentialLoginParams();

            params.DateFrom = this.State.DateFrom;
            params.DateTo = this.State.DateTo;
            params.Status = this.State.Status;
            params.CredentialType = this.State.CredentialType !== undefined ? this.State.CredentialType : -999;
            params.CredentialID = this.State.CurrentCredentialID;

            return this.credentialActivityEndpoint.ListLogins(params, options);
        }, undefined, undefined, false);

        this.DS['UserLogins']?.Reload();
    }

    override InitState() {
        this.State.DateFrom = DateHelpers.BOM(new Date());
        this.State.DateTo = DateHelpers.EOM(new Date());
        this.State.Status = EnumUserLoginStatus.All;
        this.State.CredentialType = -1;
        this.State.CurrentCredentialID = null;

        this.ReadQuery();
    }

    override OnGetToolbarSettings() {
        const settings = new ToolbarSettings;
        settings.IsAllowFilter = true;
        settings.IsAllowExport = true;
        settings.GridExtender = this.grid?.G;

        return settings;
    }

    override OnApplyFilter() {
        this.LoadDataSource();
    }

    override OnClearFilter() {
        this.InitState();
        this.LoadDataSource();
    }

    private LoadCredentials() {
        this.DataSources['Credentials'] =
            new DataSourceCustomAction((options) => this.webAPICredentialEndpoint.GetList(options),
                (entryID) => this.webAPICredentialEndpoint.Get(entryID));
    }

    private ReadQuery() {
        if (this.QueryParams.CredentialID) {
            this.State.CurrentCredentialID = +this.QueryParams.CredentialID;
        }
    }

    OnRefresh() {
        this.LoadDataSource();
    }
}
